import { Redirect, Switch } from "react-router";

import { useAuthContext } from "@/modules/auth/hooks/useAuthContext";
import { anonymousRouting } from "@/modules/router/routings/anonymousRouting";
import { authenticatedRouting } from "@/modules/router/routings/authenticatedRouting";
import { PageLoader } from "@/modules/theme/components/Loader/PageLoader";
import { AnonymousNotFoundPage } from "@/pages/404NotFound/AnonymousNotFoundPage";
import { AuthenticatedNotFoundPage } from "@/pages/404NotFound/AuthenticatedNotFoundPage";
import { ChangePasswordPage } from "@/pages/ChangePasswordPage/ChangePasswordPage";
import { ResetPasswordSuccessPage } from "@/pages/ChangePasswordSuccessPage/ResetPasswordSuccessPage";
import { SetupPasswordSuccessPage } from "@/pages/ChangePasswordSuccessPage/SetupPasswordSuccessPage";
import { DashboardPage } from "@/pages/DashboardPage/DashboardPage";
import { DashboardTaskDetailsPage } from "@/pages/DashboardTaskDetailsPage/DashboardTaskDetailsPage";
import { HandbooksPage } from "@/pages/HandbooksPage/HandbooksPage";
import { LevelCongratulationsPage } from "@/pages/LevelCongratulationsPage/LevelCongratulationsPage";
import { LevelsPage } from "@/pages/LevelsPage/LevelsPage";
import { MoreMenuPage } from "@/pages/MoreMenuPage/MoreMenuPage";
import { ResetPasswordConfirmationPage } from "@/pages/ResetPasswordConfirmationPage/ResetPasswordConfirmationPage";
import { ResetPasswordPage } from "@/pages/ResetPasswordPage/ResetPasswordPage";
import { SetupPasswordPage } from "@/pages/SetupPasswordPage/SetupPasswordPage";
import { SignInPage } from "@/pages/SignInPage/SignInPage";
import { SignOutPage } from "@/pages/SignOutPage/SignOutPage";
import { DoneSubtaskDetailsPage } from "@/pages/SubtaskDetailsPage/DoneSubtaskDetailsPage";
import { UndoneSubtaskDetailsPage } from "@/pages/SubtaskDetailsPage/UndoneSubtaskDetailsPage";
import { TaskDetailsPage } from "@/pages/TaskDetailsPage/TaskDetailsPage";
import { TasksPage } from "@/pages/TasksPage/TasksPage";
import { TestFailedPage } from "@/pages/TestFailedPage/TestFailedPage";
import { TestPassedPage } from "@/pages/TestPassedPage/TestPassedPage";
import { TutorialDetailsPage } from "@/pages/TutorialDetailsPage/TutorialDetailsPage";
import { TutorialsPage } from "@/pages/TutorialsPage/TutorialsPage";
import { TutorialTestPage } from "@/pages/TutorialTestPage/TutorialTestPage";

const AnonymousRoutes = anonymousRouting.Routes;
const AuthenticatedRoutes = authenticatedRouting.Routes;

export function Routes() {
  const auth = useAuthContext();

  if (auth.isLoading) {
    return <PageLoader />;
  }

  return auth.userId ? (
    <AuthenticatedRoutes
      components={{
        tasks: TasksPage,
        taskDetails: TaskDetailsPage,
        doneSubtaskDetails: DoneSubtaskDetailsPage,
        undoneSubtaskDetails: UndoneSubtaskDetailsPage,
        testPassed: TestPassedPage,
        testFailed: TestFailedPage,
        tutorials: TutorialsPage,
        tutorialDetails: TutorialDetailsPage,
        tutorialTest: TutorialTestPage,
        dashboard: DashboardPage,
        dashboardTaskDetails: DashboardTaskDetailsPage,
        levels: LevelsPage,
        levelCongratulations: LevelCongratulationsPage,
        handbooks: HandbooksPage,
        more: MoreMenuPage,
        signOut: SignOutPage,
        changePassword: ChangePasswordPage,
      }}
      fallthroughComponent={() => (
        <Switch>
          <Redirect
            from={anonymousRouting.config.signIn.path}
            to={authenticatedRouting.config.tasks.path}
            exact
          />
          <AuthenticatedNotFoundPage />
        </Switch>
      )}
    />
  ) : (
    <AnonymousRoutes
      components={{
        signIn: SignInPage,
        resetPassword: ResetPasswordPage,
        setupPassword: SetupPasswordPage,
        resetPasswordConfirmation: ResetPasswordConfirmationPage,
        resetPasswordSuccess: ResetPasswordSuccessPage,
        setupPasswordSuccess: SetupPasswordSuccessPage,
      }}
      fallthroughComponent={() => (
        <Switch>
          <Redirect
            from={authenticatedRouting.config.tasks.path}
            to={anonymousRouting.config.signIn.path}
            exact
          />
          <AnonymousNotFoundPage />
        </Switch>
      )}
    />
  );
}
